import { render, staticRenderFns } from "./BulkWizardReview.vue?vue&type=template&id=c4bd7534&scoped=true&"
import script from "./BulkWizardReview.vue?vue&type=script&lang=js&"
export * from "./BulkWizardReview.vue?vue&type=script&lang=js&"
import style0 from "./BulkWizardReview.vue?vue&type=style&index=0&id=c4bd7534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bd7534",
  null
  
)

export default component.exports